const PageNotFound = () => (
  <div className="flex h-full w-full flex-col items-center justify-center">
    <div className="flex flex-col items-center gap-3">
      <h1 className="text-7xl font-bold">404</h1>
      <p className="text-3xl font-bold">Page Not Found</p>
      <p className="text-lg">
        We’re sorry, the requested page could not be found.
      </p>
    </div>
  </div>
)

export default PageNotFound
